import React from 'react'
import { Link } from 'react-router-dom'
import { Rocket } from 'lucide-react'
import styles from './ProjectAutofillCard.module.scss'
import draftPublishStyles from '../DraftPublishButton.module.scss'
import PublishedPrivateProjectCard from './PublishedPrivateProjectCard.tsx'
import { PUBLISHED_RUBRO_EDIT_HINT } from './projectAutofillCard/projectAutofillCardUtils.ts'

export type ProjectAutofillSaveFooterProps = {
  draftId: string | undefined
  dirty: boolean
  saveState: 'idle' | 'ok' | 'error'
  canSaveDraft: boolean
  isSaving: boolean
  publishSuccess: {
    proyectoId: string
    obraName: string
    subproyectoCount: number
  } | null
  alreadyPublishedFromMetadata: boolean
  publishedProyectoId: string
  canPublishDraft: boolean
  isPublishing: boolean
  publishError: string | null
  onSave: () => void
  onPublish: () => void | Promise<void>
  rail?: boolean
}

const ProjectAutofillSaveFooter: React.FC<ProjectAutofillSaveFooterProps> = ({
  draftId,
  dirty,
  saveState,
  canSaveDraft,
  isSaving,
  publishSuccess,
  alreadyPublishedFromMetadata,
  publishedProyectoId,
  canPublishDraft,
  isPublishing,
  publishError,
  onSave,
  onPublish,
  rail
}) => {
  if (!draftId) return null
  return (
    <div
      className={[styles.projectAutofillSaveFooter, rail ? styles.projectAutofillSaveFooterCreateObra : '']
        .filter(Boolean)
        .join(' ')}
    >
      {dirty && (
        <p className={styles.projectAutofillUnsavedNote}>
          Cambios sin guardar. Si "Guardar borrador" no está activo, revisá las validaciones de los rubros.
        </p>
      )}
      <div className={styles.projectAutofillSaveFooterBar}>
        <div className={styles.projectAutofillSaveStatus}>
          {saveState === 'ok' && <span className={styles.projectAutofillSaveOk}>Guardado</span>}
          {saveState === 'error' && <span className={styles.projectAutofillSaveError}>Error al guardar</span>}
        </div>
        <div className={styles.projectAutofillSaveButtons}>
          <button
            type="button"
            className={styles.projectAutofillSaveDraftButton}
            onClick={onSave}
            disabled={!canSaveDraft || isSaving || (rail && isPublishing)}
          >
            {isSaving ? 'Guardando...' : 'Guardar borrador'}
          </button>
          {publishSuccess ? null : alreadyPublishedFromMetadata ? (
            <Link
              to={`/obrasprivadas/${encodeURIComponent(publishedProyectoId)}`}
              className={styles.projectAutofillPublishedLink}
              title={PUBLISHED_RUBRO_EDIT_HINT}
            >
              Ver obra publicada
            </Link>
          ) : (
            <button
              type="button"
              className={draftPublishStyles.draftPublishButton}
              onClick={() => void onPublish()}
              disabled={!canPublishDraft || isPublishing}
            >
              {isPublishing ? (
                <span>Publicando...</span>
              ) : (
                <>
                  <Rocket size={18} strokeWidth={1.8} aria-hidden />
                  <span>Publicar obra</span>
                </>
              )}
            </button>
          )}
        </div>
      </div>
      {publishError && <p className={styles.projectAutofillPublishError}>{publishError}</p>}
      {publishSuccess && (
        <PublishedPrivateProjectCard
          proyectoId={publishSuccess.proyectoId}
          obraName={publishSuccess.obraName}
          subproyectoCount={publishSuccess.subproyectoCount}
        />
      )}
    </div>
  )
}

export default ProjectAutofillSaveFooter
